var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationServices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.23 10.126c-.34-.34-.284-.904.042-1.23.202-.195.5-.334.876-.5l11.32-5.22c.591-.27 1.008-.215 1.286.07.285.278.34.695.07 1.285l-5.22 11.328c-.166.368-.305.667-.5.869-.326.326-.89.382-1.23.041-.23-.229-.347-.597-.347-.973l-.014-5.045c0-.111-.014-.174-.049-.215-.041-.035-.104-.049-.215-.049l-5.045-.014c-.376 0-.744-.118-.973-.347z"
})));
export default SvgLocationServices;